import * as React from 'react';
import './goto-top.scss';
import { on, off } from '@byted/ecom-mobile-lib/lib/utils/dom';
export default function GoTop(props: { scrollItemId?: string }) {
    const [show, setShow] = React.useState(false);
    const scrollItem = props.scrollItemId
        ? document.getElementById(props.scrollItemId!)
        : ((window as unknown) as Element);
    function handle() {
        if (scrollItem && scrollItem.scrollTop > window.innerHeight) {
            setShow(true);
        } else {
            setShow(false);
        }
    }
    React.useEffect(() => {
        if (scrollItem) {
            on(scrollItem, 'scroll', handle);
        }
        return () => {
            scrollItem && off(scrollItem, 'scroll', handle);
        };
    }, [scrollItem]);
    if (!show) return null;
    return (
        <div
            className="top-btn"
            onClick={() => {
                scrollItem &&
                    scrollItem.scrollTo({
                        top: 0,
                        left: 0
                    });
            }}
        ></div>
    );
}
